import { Base64 } from 'js-base64'
import settlementAccountConfig from '@/server-config/settlement-account.config'

/**
 * 解密 GET /store-settings 返回的 settlementAccountEncrypted
 * @param {{ encrypted?: string, algorithm?: string, keyVersion?: string }} params
 * @returns {Promise<object|null>} 解密成功返回 settlementAccount 对象，失败返回 null
 */
export async function decryptSettlementAccount({
  encrypted,
  algorithm,
  keyVersion
} = {}) {
  try {
    if (!encrypted || typeof encrypted !== 'string') {
      return null
    }
    if (algorithm !== settlementAccountConfig.ALGORITHM) {
      return null
    }
    const keyBase64 = settlementAccountConfig.KEY_MAP[keyVersion]
    if (!keyBase64) {
      return null
    }

    const subtle = globalThis.crypto?.subtle
    if (!subtle) {
      return null
    }

    const bytes = Base64.toUint8Array(encrypted)
    const nonceLength = settlementAccountConfig.NONCE_LENGTH
    if (!bytes || bytes.length <= nonceLength) {
      return null
    }

    const iv = bytes.slice(0, nonceLength)
    const ciphertext = bytes.slice(nonceLength)
    const keyBytes = Base64.toUint8Array(keyBase64)
    const additionalData = new TextEncoder().encode(settlementAccountConfig.AAD)

    const cryptoKey = await subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['decrypt']
    )
    const plainBuffer = await subtle.decrypt(
      {
        name: 'AES-GCM',
        iv,
        additionalData,
        tagLength: 128
      },
      cryptoKey,
      ciphertext
    )
    const plainText = new TextDecoder('utf-8').decode(plainBuffer)
    return JSON.parse(plainText)
  } catch (e) {
    console.error('decryptSettlementAccount error:', e)
    return null
  }
}
